import { FolderOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { SummaryPanel } from "./SummaryPanel";
import { summaryAmount, summaryDate } from "./formatters";

export const ProjectsSummary = ({ section, currency, permissions }) => {
  const data = section.data;
  return (
    <SummaryPanel
      id="home-projects"
      title="Proyectos y entregas"
      icon={FolderOpen}
      href="/projects"
      question="¿Ganamos lo esperado y cumplimos con lo comprometido?"
      section={section}
      className="home-week-wide"
    >
      {data && (
        <>
          <p className="home-week-strip">
            {data.count} proyectos en curso · {data.attention} necesitan
            atención
            {data.next.length > 0 && ` · mostrando ${data.next.length}`}
          </p>
          {data.next.length ? (
            <div className="home-week-table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Proyecto / cliente</th>
                    {permissions.costs && <th>Rentabilidad proyectada</th>}
                    {permissions.tasks && (
                      <>
                        <th>Tareas terminadas</th>
                        <th>Próxima fecha</th>
                      </>
                    )}
                    <th>Atención</th>
                  </tr>
                </thead>
                <tbody>
                  {data.next.map((project) => (
                    <tr key={project.id}>
                      <td className="home-week-project-client">
                        <Link to={`/projects/${project.id}`}>
                          {project.referencia || "Sin referencia"}
                        </Link>
                        <small>{project.client || "Sin cliente"}</small>
                      </td>
                      {permissions.costs && (
                        <td>
                          {summaryAmount(project.profit, currency)}
                          <small>
                            Margen proyectado {project.margin ?? "—"} % · presupuestado{" "}
                            {project.target_margin ?? "—"} %
                          </small>
                        </td>
                      )}
                      {permissions.tasks && (
                        <>
                          <td>
                            {project.done} de {project.tasks}
                            <small>{project.overdue} vencidas</small>
                          </td>
                          <td>
                            {summaryDate(project.next_due)}
                            <small>Pendiente hasta el domingo</small>
                          </td>
                        </>
                      )}
                      <td>
                        {Number(project.overrun) > 0 && (
                          <span className="home-week-badge home-week-badge-alert">
                            Sobrecosto{" "}
                            {summaryAmount(project.overrun, currency)}
                          </span>
                        )}
                        {project.overdue > 0 && (
                          <span className="home-week-badge home-week-badge-alert">
                            Revisar tareas vencidas
                          </span>
                        )}
                        {!project.attention && (
                          <span className="home-week-badge">
                            Sin alertas detectadas
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="home-week-empty">
              Aún no tienes proyectos en curso en esta moneda. Los presupuestos
              aprobados y abiertos aparecerán aquí.
            </p>
          )}
          {permissions.tasks && (
            <p className="home-week-hint">
              El conteo de tareas no equivale al avance físico o al esfuerzo del
              proyecto.
            </p>
          )}
        </>
      )}
    </SummaryPanel>
  );
};
